export interface BrandKitPopupProps {
  pinnedBrandKitId: string | null;
  onBrandKitSelect: (brandKitId: string | null) => void;
  isFullWidth?: boolean;
}

export const BRAND_KIT_SKELETON_ROW_COUNT = 5;

export const BRAND_KIT_ROWS_BEFORE_SCROLL = 4;
